function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import styled from "styled-components";
import { LoaderInline } from "../";
export const Button = /*#__PURE__*/forwardRef((props, ref) => (({
  disabled,
  onClick,
  iconLeft,
  iconRight,
  type = "primary",
  loading,
  children,
  forwardRef,
  ...props
}) => /*#__PURE__*/React.createElement(StyledButtonBase, _extends({
  disabled: disabled || loading,
  onClick: disabled ? undefined : onClick,
  type: "button",
  variant: type
}, props, {
  ref: forwardRef
}), !loading ? /*#__PURE__*/React.createElement(React.Fragment, null, iconLeft && /*#__PURE__*/React.createElement(IconLeftContainer, null, iconLeft), children, iconRight && /*#__PURE__*/React.createElement(IconRightContainer, null, iconRight)) : /*#__PURE__*/React.createElement(LoaderInline, null)))({ ...props,
  forwardRef: ref
}));
export const StyledButtonBase = styled.button`
  ${props => props.theme.typography.button};
  ${props => props.theme.button.global};
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  text-align: center;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border-style: solid;
  ${props => props.theme.button[props.variant]};

  &:not(:disabled):hover,
  &:not(:disabled):focus {
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
    ${props => props.theme.button[props.variant].hover};
  }
  &:disabled {
    ${props => props.theme.button.disabled};
    ${props => props.theme.button[props.variant].disabled};
  }
`;
const IconContainer = styled.div`
  align-items: center;
  display: flex;
  height: 22px;
`;
const IconLeftContainer = styled(IconContainer)`
  margin-right: 8px;
`;
const IconRightContainer = styled(IconContainer)`
  margin-left: 8px;
`;